import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
    $(document).off('click', '.menu-toggle');
    $(document).on('click', '.menu-toggle', function () {
      $('#sidebar').toggleClass('collapsed');
    });

    $(document).off('click', '.hasSubMenu > a');
    $(document).on('click', '.hasSubMenu > a', function () {
      $(this).parents('.hasSubMenu').toggleClass('opened');
      $(this).parents('.hasSubMenu').find('ul').slideToggle();
    });
  }
}
